fragment AccountDuplicateFragment on Account {
    id
    hasDuplicates
}
